var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow2Directions(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow-2-directions_svg__clip0_7598_70989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.812 14.23l3.492-3.491a1.166 1.166 0 000-1.648l-3.492-3.492a1.166 1.166 0 00-1.648 1.647l1.506 1.506H4.993L6.5 7.246a1.166 1.166 0 00-1.648-1.648L1.36 9.091a1.166 1.166 0 000 1.648l3.492 3.492A1.166 1.166 0 006.5 12.583l-1.502-1.502h10.677l-1.506 1.506a1.166 1.166 0 001.648 1.648l-.004-.004z",
    fill: "#0D2976"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow-2-directions_svg__clip0_7598_70989"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(1 0 0 -1 0 20)",
    d: "M0 0h20v20H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2Directions);
export default ForwardRef;